/*
 * @Author: your name
 * @Date: 2021-08-20 15:06:15
 * @LastEditTime: 2022-02-27 09:36:32
 * @LastEditors: Please set LastEditors
 * @Description: 项目基础配置
 * @FilePath: \vue-element-ui-admin\src\store\modules\app.js
 */
import {
  getViewPortHeight,
  getTableHeight,
  getViewPortWidth,
  getContentViewWidth,
  getContentViewHeight
} from "@/utils/index.js";
const heightTemp = getTableHeight("all"); //获取初始值

export const app = {
  state: {
    windowResizeCount: 0, //用于全局监听窗口大小改变事件
    windowHeight: getViewPortHeight(), //浏览器高度
    windowWidth: getViewPortWidth(), // 浏览器宽度
    contentViewWidth: getContentViewWidth(), // 内容区域宽度
    contentViewHeight: getContentViewHeight(), // 内容区域高度度

    tableHeight: heightTemp.tableHeight, //（该字段没有维护，不建议用）表格高度，不包含pagination的高度，但是请谨慎使用，因为不同页面的表格上方操作栏的高度不同
    contentHeight: heightTemp.contentHeight, // （该字段没有维护，不建议用）content区域高度，即表格+页码的高度，不包括表格上方的操作栏，但是请谨慎使用，因为不同页面的表格上方操作栏的高度不同
    mainHeight: getViewPortHeight() - 88 // （该字段没有维护，不建议用） 布局区域的高度
  },
  mutations: {
    setContentHeight(state, mainHeight) {
      state.mainHeight = mainHeight; // border+padding
      state.contentViewHeight = getContentViewHeight();
      // 设置content区域高度，以及table高度
      let height = getTableHeight("all");
      setTimeout(() => {
        //一定要延时，否则当表格上方的操作区元素而换行（2行高度会被撑高）时，table高度不能正确显示
        state.contentHeight = height.contentHeight;
        state.tableHeight = height.tableHeight;
      }, 500);
    },
    setContentViewWidth(state) {
      state.contentViewWidth = getContentViewWidth();
      console.log(state.contentViewWidth);
    },
    setWindowResize(state) {
      state.windowResizeCount++;
      state.windowHeight = getViewPortHeight();
    }
  },
  getters: {}
};
